import upperFirst from 'lodash/fp/upperFirst';
import { Breakpoints } from '../../../components/Breakpoint/Breakpoint';

export type ResponsiveSelector = {
  thinnerThan?: Breakpoints;
  widerThan?: Breakpoints;
  at?: Breakpoints;
};
// Alias for backwards compatibility
export type ResponsiveHiddenShape = ResponsiveSelector;

export default function getResponsiveClasses({
  styles,
  prefix,
  selector: { thinnerThan, widerThan, at } = {},
}: {
  styles: CSSModule;
  prefix: string;
  selector?: ResponsiveSelector;
}) {
  const classes: string[] = [];

  if (thinnerThan) {
    classes.push(styles[`${prefix}thinnerThan${upperFirst(thinnerThan)}`]);
  }
  if (widerThan) {
    classes.push(styles[`${prefix}widerThan${upperFirst(widerThan)}`]);
  }
  if (at) {
    classes.push(styles[`${prefix}at${upperFirst(at)}`]);
  }

  return classes;
}
